export default "__VITE_ASSET__C9HslfQc__"